import { create } from 'zustand';
import ServiceAuditoria from '@/services/ServiceAuditoria';
import { notify } from '@/stores/useToast';

type Item = any;

interface Filtros {
  fromTime?: string;
  toTime?: string;
  userNames?: string[];
  ipAddresses?: string[];
  actions?: string[];
  services?: string[];
}
interface Opcoes {
  users: string[];
  ips: string[];
  actions: string[];
  services: string[];
}

interface State {
  lista: Item[];
  total: number;
  carregando: boolean;
  page: number;
  size: number;
  filtros: Filtros;
  opcoes: Opcoes;
  setFiltros: (f: Filtros) => void;
  setPage: (page: number) => Promise<void>;
  setSize: (size: number) => Promise<void>;
  buscar: () => Promise<void>;
  carregarOpcoes: () => Promise<void>;
  exportar: () => Promise<void>;
}

export const useAuditoriaStore = create<State>((set, get) => ({
  lista: [],
  total: 0,
  carregando: false,
  page: 0,
  size: 50,
  filtros: {},
  opcoes: { users: [], ips: [], actions: [], services: [] },
  setFiltros: (f) => set({ filtros: f, page: 0 }),
  async setPage(page) {
    set({ page });
    await get().buscar();
  },
  async setSize(size) {
    set({ size, page: 0 });
    await get().buscar();
  },
  async buscar() {
    set({ carregando: true });
    try {
      const { data } = await ServiceAuditoria.listar(get().filtros, {
        page: get().page,
        size: get().size,
      });
      set({ lista: data.content ?? [], total: data.totalElements ?? 0 });
    } catch {
      notify.error('Erro ao buscar auditoria.');
    } finally {
      set({ carregando: false });
    }
  },
  async carregarOpcoes() {
    try {
      const { data } = await ServiceAuditoria.opcoes(get().filtros.fromTime, get().filtros.toTime);
      set({ opcoes: data });
    } catch {
      notify.error('Erro ao carregar filtros.');
    }
  },
  async exportar() {
    try {
      const { data } = await ServiceAuditoria.exportar(get().filtros);
      const url = URL.createObjectURL(new Blob([data]));
      const a = document.createElement('a');
      a.href = url;
      a.download = 'auditoria.xlsx';
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      notify.error('Erro ao exportar auditoria.');
    }
  },
}));
